import { ReactNode } from "react";
import { Header } from "../Header";
import { BOOKING_URL } from "../../constants/links";
import { useTranslation } from "react-i18next";

type Props = {
  children: ReactNode;
  headerVariant?: "default" | "simple";
};

export const PageShell = ({ children }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Header navLink={BOOKING_URL} buttonTitle={t("book-now")} />
      {children}
    </>
  );
};
